/**
 * Hook that allows to parse value with "," into number string with "."
 *
 * @param {string | number | null | undefined} value
 * @returns {string | null}
 */
export const parseFloatValue = (value: string | number | null | undefined): string | null =>
    value !== undefined && value !== null ? value.toString().replace(',', '.') : null;
